import React, { useEffect } from 'react';
import { Typography } from '@banhala/ui-kit';
import { convertToDayJs, getCurrentTimeDiff, isNil } from 'shared/src/utils';

const getRemainTimeText = (time: string) => {
  const convertedTime = convertToDayJs(time);

  const diffSecond = getCurrentTimeDiff(convertedTime, 'second');
  const diffHourText = Math.abs(getCurrentTimeDiff(convertedTime, 'hour'));
  const diffMinute = Math.abs(getCurrentTimeDiff(convertedTime, 'minute'));
  const diffMinuteText = diffMinute - diffHourText * 60;
  const diffSecondText =
    Math.abs(getCurrentTimeDiff(convertedTime, 'second')) - diffMinute * 60;

  const isTimeOver = diffSecond > 0;

  if (isTimeOver) return null;

  return `${diffHourText < 10 ? `0${diffHourText}` : diffHourText} : ${diffMinuteText < 10 ? `0${diffMinuteText}` : diffMinuteText} : ${diffSecondText < 10 ? `0${diffSecondText}` : diffSecondText}`;
};

export const TimerText: React.FC<{ expiredAt: string }> = props => {
  const [text, setText] = React.useState<string | null>(() =>
    getRemainTimeText(props.expiredAt),
  );

  const [isTimeOver, setIsTimeOver] = React.useState(false);

  useEffect(() => {
    const timerRef = setInterval(() => {
      const nextText = getRemainTimeText(props.expiredAt);
      setText(nextText);
      setIsTimeOver(isNil(nextText));
    });

    return () => {
      clearInterval(timerRef);
    };
  }, [props.expiredAt]);

  if (isNil(text)) return null;

  if (isTimeOver) return null;

  return (
    <Typography color={'content_pink_primary'} type={'subtitle3'}>
      {text}
    </Typography>
  );
};
